<ng-content select="[left]"></ng-content>

<div class="row-title" [class]="type" [style.color]="color">{{ name }}</div>

<ng-content></ng-content>

